<template>   
   <div class="success-alerts">
      <div v-for="message in messages" v-bind:key="message" class="alert alert-success">{{ message }}</div>
   </div>
</template>

<script>
export default {
   props: [
      'messages'
   ],

   methods:{
   }// /methods{}
   
};
</script>

<style scoped>
</style>